import React from 'react';
import PropTypes from 'prop-types';

const PublicPartnerSkyworkAffiliations = ({items, labels, loading, onRequest}) => {
  const titlePrimary = labels.titleAccent && labels.title.endsWith(labels.titleAccent)
    ? labels.title.slice(0, -labels.titleAccent.length).trim()
    : labels.title;

  return (
    <section
      id="club-affiliations"
      className="replayer-club-page__affiliations"
      aria-label={labels.ariaLabel}
    >
    <header className="replayer-club-page__affiliations-heading">
      <span className="replayer-club-page__journey-number" aria-hidden="true">
        {labels.number}
      </span>
      <div>
        <p className="replayer-club-page__eyebrow">{labels.eyebrow}</p>
        <h2>
          <span className="replayer-club-page__affiliations-title-primary">{titlePrimary}</span>
          {labels.titleAccent && (
            <span className="replayer-club-page__affiliations-title-accent">{labels.titleAccent}</span>
          )}
        </h2>
        <p>{labels.intro}</p>
      </div>
    </header>

    {loading && (
      <div className="replayer-club-page__affiliations-state" role="status">
        <span className="replayer-club-page__affiliations-loader" aria-hidden="true"/>
        <span>{labels.loading}</span>
      </div>
    )}

    {!loading && items.length === 0 && (
      <p className="replayer-club-page__affiliations-state">
        {labels.empty}
      </p>
    )}

    {!loading && items.length > 0 && (
      <div className="replayer-club-page__affiliations-grid">
        {items.map(item => (
          <article
            className={`replayer-club-page__affiliation replayer-club-page__affiliation--${item.status}`}
            key={item.id}
          >
            <div className="replayer-club-page__affiliation-icon">
              <img src={item.icon} alt="" aria-hidden="true"/>
            </div>
            <div className="replayer-club-page__affiliation-copy">
              <div className="replayer-club-page__affiliation-title-row">
                <h3>{item.name}</h3>
                <span>{item.statusShortLabel}</span>
              </div>
              <p>{item.statusLabel}</p>
              {item.paymentLabel && (
                <small>{item.paymentLabel}</small>
              )}
              {item.benefits.length > 0 && (
                <ul className="replayer-club-page__affiliation-benefits">
                  {item.benefits.map(benefit => (
                    <li key={benefit.id}>{benefit.label}</li>
                  ))}
                </ul>
              )}
            </div>
            <button
              type="button"
              aria-label={`${item.name}: ${item.actionLabel}`}
              disabled={item.disabled}
              onClick={() => onRequest(item.id)}
              title={item.statusLabel}
            >
              {item.actionLabel}
              {!item.disabled && <span aria-hidden="true">→</span>}
            </button>
          </article>
        ))}
      </div>
    )}
    </section>
  );
};

PublicPartnerSkyworkAffiliations.propTypes = {
  items: PropTypes.arrayOf(PropTypes.shape({
    actionLabel: PropTypes.string.isRequired,
    benefits: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired
    })).isRequired,
    disabled: PropTypes.bool.isRequired,
    icon: PropTypes.string.isRequired,
    id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    name: PropTypes.string.isRequired,
    paymentLabel: PropTypes.string,
    status: PropTypes.string.isRequired,
    statusLabel: PropTypes.string.isRequired,
    statusShortLabel: PropTypes.string.isRequired
  })),
  labels: PropTypes.shape({
    ariaLabel: PropTypes.string.isRequired,
    empty: PropTypes.string.isRequired,
    eyebrow: PropTypes.string.isRequired,
    intro: PropTypes.string.isRequired,
    loading: PropTypes.string.isRequired,
    number: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    titleAccent: PropTypes.string
  }).isRequired,
  loading: PropTypes.bool,
  onRequest: PropTypes.func.isRequired
};

PublicPartnerSkyworkAffiliations.defaultProps = {
  items: [],
  loading: false
};

export default PublicPartnerSkyworkAffiliations;
